(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-reference-review-i18n"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-review-i18n')) {
  customElements.define('mh-review-i18n', class extends HTMLElement {
    connectedCallback() {
      this.dictionary = JSON.parse(this.querySelector('script').textContent);
      this.translate = value => {
        const trimmed = value.trim();
        let translated = this.dictionary[trimmed];
        const count = trimmed.match(/^Basierend auf (\d+) Bewertungen$/);
        const page = trimmed.match(/^Go to page (\d+)$/);
        if (count) translated = this.dictionary['Basierend auf __COUNT__ Bewertungen'].replace('__COUNT__', count[1]);
        if (page) translated = this.dictionary['Go to page __PAGE__'].replace('__PAGE__', page[1]);
        return translated ? value.replace(trimmed, translated) : value;
      };
      this.update = () => {
        this.frame = null;
        const roots = document.querySelectorAll('[id$="__reference_reviews"], .areviews_header_stars');
        roots.forEach(root => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          while (walker.nextNode()) {
            const node = walker.currentNode;
            if (node.parentElement.closest('script,style,.comment,.areviews_user_name,.AreviewsModal_review_text')) continue;
            const translated = this.translate(node.data);
            if (translated !== node.data) node.data = translated;
          }
          root.querySelectorAll('[placeholder],[aria-label],[title]').forEach(element => {
            for (const attribute of ['placeholder', 'aria-label', 'title']) {
              if (!element.hasAttribute(attribute)) continue;
              const value = element.getAttribute(attribute);
              const translated = this.translate(value);
              if (translated !== value) element.setAttribute(attribute, translated);
            }
          });
          if (!this.observed.has(root)) {
            this.observed.add(root);
            this.observer.observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['placeholder','aria-label','title']});
          }
        });
      };
      this.schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.update);
      };
      this.observed = new WeakSet();
      this.observer = new MutationObserver(this.schedule);
      this.start = () => {
        this.update();
        const reviews = document.querySelector('[id$="__reference_reviews"]');
        if (reviews) this.observer.observe(reviews, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['placeholder','aria-label','title']});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once:true});
      else this.start();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      this.observer?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
